import React, { useState } from "react";
import {
  Row,
  Column,
  FormGroup,
  TextArea,
  RadioButtonGroup,
  RadioButton,
  TextInput,
} from "carbon-components-react";
import useAuth from "../../hooks/useAuth";

const CapacityAnalysisForm = ({
  disabled,
  register,
  errors,
  hasBusinessCurrently,
  setHasBusinessCurrently,
}) => {
  return (
    <FormGroup
      legendText="4. ANÁLISE DAS CAPACIDADES E OPORTUNIDADES DE MELHORIA"
      className="section-header"
    >
      <h6 className="section-subtitle">
        A ser preenchida por todos/as candidatos/as independentemente se tem ou
        não um negócio actualmente.
      </h6>
      <fieldset fieldset className="bx--fieldset">
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              id="companyQualities"
              labelText="4.1 Que qualidades, aspectos ou características positivas internas da sua empresa (se existente) ou a ser criada, possui? "
              rows={5}
              enableCounter
              disabled={disabled}
              helperText="[Use no máximo 100 palavras.]"
              {...register("companyQualities")}
            />
            <p className="field-error">{errors.companyQualities?.message}</p>
          </Column>
        </Row>
      </fieldset>
      <fieldset fieldset className="bx--fieldset">
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              id="whatNeedsToBeStrengthened"
              labelText="4.2 Que aspectos ou características internas da sua empresa (se existente) ou a ser criada, que necessitam de ser fortalecidos? "
              rows={5}
              enableCounter
              disabled={disabled}
              helperText="[Use no máximo 100 palavras.]"
              {...register("whatNeedsToBeStrengthened")}
            />
            <p className="field-error">
              {errors.whatNeedsToBeStrengthened?.message}
            </p>
          </Column>
        </Row>
      </fieldset>
      <fieldset fieldset className="bx--fieldset">
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              id="favorableExternalContextAspects"
              labelText="4.3 Que aspectos do contexto externo da sua empresa (se existente) ou a ser criada, são favoráveis?"
              rows={5}
              enableCounter
              disabled={disabled}
              helperText="[Use no máximo 100 palavras.]"
              {...register("favorableExternalContextAspects")}
            />{" "}
            <p className="field-error">
              {errors.favorableExternalContextAspects?.message}
            </p>
          </Column>
        </Row>
      </fieldset>
      <fieldset fieldset className="bx--fieldset">
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              id="unfavorableExternalContextAspects"
              labelText="4.4 Que aspectos do contexto externo da sua empresa (se existente) ou a ser criada, são desfavoráveis? "
              rows={5}
              enableCounter
              disabled={disabled}
              helperText="[Use no máximo 100 palavras.]"
              {...register("unfavorableExternalContextAspects")}
            />{" "}
            <p className="field-error">
              {errors.unfavorableExternalContextAspects?.message}
            </p>
          </Column>
        </Row>
      </fieldset>
    </FormGroup>
  );
};

CapacityAnalysisForm.defaultProps = {
  disabled: false,
};
export default CapacityAnalysisForm;
